import { currencyFormat } from '../validation/expressions';

export function currencyTransform(value: string) {
  const expression = currencyFormat;

  if (expression.test(value) === false) {
    value = value.substring(0, value.length - 1);
  }

  if (value.substring(0, 1) === '$') {
    return value;
  }

  if (value === '') {
    return value;
  }
  return `$${value}`;
}
